import CardPopoverMenu from "./card-popover-menu";

export default CardPopoverMenu;